/* src/app/modules_v2/finance/credit-policy/components/credit-policy-form-dialog/credit-policy-form-dialog.component.scss */
:host {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  min-width: 0;
}
.cpf-header-text {
  min-width: 0;
  padding-right: 36px;
}
.cpf-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;
}
.cpf-uid {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 4px;
}
.cpf-uid__value {
  font-family: monospace;
  font-size: 12px;
  color: #6b7280;
  word-break: break-all;
}
.cpf-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  border: none;
  background: none;
  font-size: 13px;
  font-weight: 600;
  color: #4d7a00;
  cursor: pointer;
}
.cpf-link mat-icon {
  font-size: 16px;
  width: 16px;
  height: 16px;
}
/*# sourceMappingURL=credit-policy-form-dialog.component.css.map */
